export const importPagePath = "/imports/";
export const importPageUrl = importPagePath;
